import { render, staticRenderFns } from "./Footer-1.vue?vue&type=template&id=0d6e6c5c&scoped=true"
import script from "./Footer-1.vue?vue&type=script&lang=js"
export * from "./Footer-1.vue?vue&type=script&lang=js"
import style0 from "./Footer-1.vue?vue&type=style&index=0&id=0d6e6c5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e6c5c",
  null
  
)

export default component.exports